import { TResetPasswordRequest } from "src/@types/clients";
import GenericDAO from "../../GenericDAO";

const route = "/v1/clients/:id/reset-password";

const save = async (data: TResetPasswordRequest) => GenericDAO.putWithId(route, data, undefined, true);

export default {
    save
};